export default "__VITE_ASSET__BWF$25TO__"